export enum CustomFieldTypes {
  Unknown,
  String,
  Number,
  DateTime,
  Boolean,
  Object,
  ArrayString,
  Upload,
}
